import request from "./request";

export function getList(id) {
  return request({
    url: 'api/getData?code='+id,
    method: 'get',
  })
}

